<template>
  <router-link
    :to="`/dashboard/fertilizers/${type}/${data.id}`"
    class="view-item"
    :class="id == data.id ? 'router-link-active' : ''"
  >
    <div ref="wrapper" class="wrapper --selector-overlay-pointer">
      <div class="title">
        {{ data.name }}
      </div>
      <div class="type">
        <!-- TODO проверить переводы -->
        {{ $ml.get(data.type) }}
      </div>
    </div>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    data: {},
    id: String
  },
  computed: {
    ...mapGetters({
      type: 'fertilizers/getType',
      // page: 'fertilizers/getPage'
    }),
  }
}
</script>

<style lang="scss" scoped>

.view-item {
  display: flex;
  flex-direction: column;
  padding: 5px 0;

  border-top: 1px solid rgba(76, 80, 86, 0.10);

  &.router-link-active {
    .title {
      color: #fff;
    }

    .type {
      color: #fff;
    }
  }

  .wrapper {
    padding: 8px 20px;
    z-index: 1;
  }

  .title {
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 5px;

    transition: color 0.5s ease;
  }

  .type {
    color: #8B8D91;
    font-weight: bold;
    font-size: 15px;
    letter-spacing: 0.05em;
    margin-top: -3px;
    transition: color 0.5s ease;
  }
}

</style>
